export const BASE_URL = "https://api-sandbox.shobbu.com/v1";

export const CLIENT_ID = "575536642152-u41ncl0uds8ralnsjv6aajptt4priuiq.apps.googleusercontent.com";
